import React from 'react';
import logo from '../../images/frugal_logo_with_name.png';

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import theme from '../../theme';

const settings = require("../../utils/settings");


export default function LandingHeader(props) {
   const noButtons = props?.noButtons ?? false;

   const renderButtons = () => {
      if (noButtons) {
         return null; // Don't render any buttons
      } else {
         return (
            <> {/* Use a Fragment to wrap multiple elements */}
               <Button variant="outlined" color="primary" href="/login" sx={{ margin: '12px' }}>
                  Login
               </Button>
               <Button variant="contained" color="primary" href="/register" sx={{ margin: '12px' }}>
                  Register
               </Button>
            </>
         );
      }
   };

   return (

      <Grid flexGrow={1}>
         <Grid size={{ lg: 12 }} sx={{minHeight: '75px', background: '#2c2c2c'}} alignItems={"center"}>
            <Grid container justifyContent={"flex-start"} sx={{paddingTop: "10px", paddingLeft: "10px"}}>
               <img src={logo} alt="app logo"/>
            </Grid>
         </Grid>
         <Grid size={{ xs: 12}} sx={{minHeight: '70px', background: theme.palette.secondary.main }} justifyContent={"flex-end"} alignContent={"center"}></Grid>
         <Grid container justifyContent={"flex-end"} sx={{backgroundColor: '#f5f5f5'}}>
            <Grid>
               {renderButtons()}
            </Grid>
         </Grid>
      </Grid>



   );
}
